import React from 'react';
import { Accordion, Button, ButtonGroup, InputGroup } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import { FaSearch } from 'react-icons/fa';

export default SAEForm = ({ formData, onFormChange, counts }) => {

    const [toggle, setToggle] = React.useState('bachelors');

    const defaultForm = {
        filter: 'ic2025',
        toggle: 'bachelors',
        institution: '',
        stabbr: ''
    };

    const control = [
        { "value": 1, "label": "Public" },
        { "value": 2, "label": "Private Not-for-profit" },
        { "value": 3, "label": "Private For-Profit" }
    ];

    const size = [
        { "value": 5, "label": "Very Large" },
        { "value": 4, "label": "Large" },
        { "value": 3, "label": "Medium" },
        { "value": 2, "label": "Small" },
        { "value": 1, "label": "Very Small" }
    ];

    const saec2025 = [
        { "value": 1, "label": "Lower Access, Lower Earnings" },
        { "value": 2, "label": "Higher Access, Lower Earnings" },
        { "value": 3, "label": "Lower Access, Medium Earnings" },
        { "value": 4, "label": "Higher Access, Medium Earnings" },
        { "value": 5, "label": "Lower Access, Higher Earnings" },
        { "value": 6, "label": "Opportunity Colleges and Universities - Higher Access, Higher Earnings" }
    ];

    const states = {
        "AL": "Alabama",
        "AK": "Alaska",
        "AZ": "Arizona",
        "AR": "Arkansas",
        "CA": "California",
        "CO": "Colorado",
        "CT": "Connecticut",
        "DE": "Delaware",
        "DC": "District Of Columbia",
        "FL": "Florida",
        "GA": "Georgia",
        "HI": "Hawaii",
        "ID": "Idaho",
        "IL": "Illinois",
        "IN": "Indiana",
        "IA": "Iowa",
        "KS": "Kansas",
        "KY": "Kentucky",
        "LA": "Louisiana",
        "ME": "Maine",
        "MD": "Maryland",
        "MA": "Massachusetts",
        "MI": "Michigan",
        "MN": "Minnesota",
        "MS": "Mississippi",
        "MO": "Missouri",
        "MT": "Montana",
        "NE": "Nebraska",
        "NV": "Nevada",
        "NH": "New Hampshire",
        "NJ": "New Jersey",
        "NM": "New Mexico",
        "NY": "New York",
        "NC": "North Carolina",
        "ND": "North Dakota",
        "OH": "Ohio",
        "OK": "Oklahoma",
        "OR": "Oregon",
        "PA": "Pennsylvania",
        "RI": "Rhode Island",
        "SC": "South Carolina",
        "SD": "South Dakota",
        "TN": "Tennessee",
        "TX": "Texas",
        "UT": "Utah",
        "VT": "Vermont",
        "VA": "Virginia",
        "WA": "Washington",
        "WV": "West Virginia",
        "WI": "Wisconsin",
        "WY": "Wyoming",
        "AS": "American Samoa",
        "FM": "Federated States Of Micronesia",
        "GU": "Guam",
        "MH": "Marshall Islands",
        "MP": "Northern Mariana Islands",
        "PW": "Palau",
        "PR": "Puerto Rico",
        "VI": "Virgin Islands"
    }

    const research = [
        { "value": 1, "label": "Research 1: Very High Spending and Doctorate Production" },
        { "value": 2, "label": "Research 2: High Spending and Doctorate Production" },
        { "value": 3, "label": "Research Colleges and Universities" }
    ];

    const ic2025 = {
        'Associate': [
            { "value": 1, "label": "Mixed Associate Large", "tab": "associates" },
            { "value": 2, "label": "Mixed Associate Medium", "tab": "associates" },
            { "value": 3, "label": "Mixed Associate Small", "tab": "associates" },
            { "value": 11, "label": "Professions-focused Associate Large/Medium", "tab": "associates" },
            { "value": 12, "label": "Professions-focused Associate Small", "tab": "associates" },
        ], 'Associate/Baccalaureate': [
            { "value": 4, "label": "Mixed Associate/Baccalaureate", "tab": "associates" },
            { "value": 13, "label": "Professions-focused Associate/Baccalaureate", "tab": "associates" },
        ], 'Baccalaureate': [
            { "value": 5, "label": "Mixed Baccalaureate", "tab": "bachelors" },
            { "value": 14, "label": "Professions-focused Baccalaureate Medium", "tab": "bachelors" },
            { "value": 15, "label": "Professions-focused Baccalaureate Small", "tab": "bachelors" },
        ], 'Undergraduate/Graduate-Master\'s': [
            { "value": 9, "label": "Mixed Undergraduate/Graduate-Master's Large/Medium", "tab": "bachelors" },
            { "value": 10, "label": "Mixed Undergraduate/Graduate-Master's Small", "tab": "bachelors" },
            { "value": 19, "label": "Professions-focused Undergraduate/Graduate-Master's Large/Medium", "tab": "bachelors" },
            { "value": 20, "label": "Professions-focused Undergraduate/Graduate-Master's Small", "tab": "bachelors" },
        ], 'Undergraduate/Graduate-Doctorate': [
            { "value": 6, "label": "Mixed Undergraduate/Graduate-Doctorate Large", "tab": "bachelors" },
            { "value": 7, "label": "Mixed Undergraduate/Graduate-Doctorate Medium", "tab": "bachelors" },
            { "value": 8, "label": "Mixed Undergraduate/Graduate-Doctorate Small", "tab": "bachelors" },
            { "value": 16, "label": "Professions-focused Undergraduate/Graduate-Doctorate Large", "tab": "bachelors" },
            { "value": 17, "label": "Professions-focused Undergraduate/Graduate-Doctorate Medium", "tab": "bachelors" },
            { "value": 18, "label": "Professions-focused Undergraduate/Graduate-Doctorate Small", "tab": "bachelors" },
        ], 'Special Focus': [
            { "value": 21, "label": "Special Focus: Applied and Career Studies", "tab": "sf" },
            { "value": 22, "label": "Special Focus: Arts and Sciences", "tab": "associates" },
            { "value": 23, "label": "Special Focus: Arts, Music, and Design", "tab": "sf" },
            { "value": 24, "label": "Special Focus: Business", "tab": "sf" },
            { "value": 28, "label": "Special Focus: Nursing", "tab": "sf" },
            { "value": 29, "label": "Special Focus: Other Health Professions", "tab": "sf" },
            { "value": 30, "label": "Special Focus: Technology, Engineering, and Sciences", "tab": "bachelors" },
        ]
    };

    let alf = [
        { "value": 1, "label": "Associate" },
        { "value": 2, "label": "Associate/Baccalaureate" },
        { "value": 3, "label": "Baccalaureate" },
        { "value": 4, "label": "Undergraduate/Graduate-Master's" },
        { "value": 5, "label": "Undergraduate/Graduate-Doctorate" },
        { "value": 6, "label": "Graduate-focused" }
    ];

    function handleFormChange(field, value) {
        let newFormData = { ...formData };

        if (newFormData[field] == null) {
            newFormData[field] = [];
        }
        if (newFormData[field].includes(value)) {
            newFormData[field] = newFormData[field].filter((item) => item !== value);
            if (newFormData[field].length == 0) {
                delete newFormData[field];
            }
        } else {
            newFormData[field].push(value);
        }
        onFormChange(newFormData);
    }

    function handleChecked(control, value) {
        if (formData[control] == null) {
            return false;
        }
        let c = formData[control].find((item) => item == value);
        return c != null;
    }

    return (
        <Form className='' onSubmit={(e) => { e.preventDefault(); }}>
            <div className='d-flex justify-content-between align-items-center mb-3 '>
                <h2 htmlFor="breakoutSelect">
                    FILTERS
                </h2>
                <a alt="Clear the filters" id="clearFiltersElem" href="#" onClick={(e) => {
                    e.preventDefault();
                    setToggle('bachelors')
                    onFormChange(defaultForm);
                    formData.state = '';
                }}>Clear Filters</a>
            </div>
            <ButtonGroup vertical aria-label="Type Toggle" className='mb-3 saecToggle w-100'>
                <Button
                    className='d-flex justify-content-between'
                    variant={toggle == 'bachelors' ? 'active' : ''}
                    onClick={(e) => {
                        let newFormData = { ...formData };
                        newFormData.filter = 'ic2025';
                        newFormData.toggle = 'bachelors';
                        setToggle('bachelors')
                        onFormChange(newFormData);
                    }}>
                    <span>Baccalaureate and Above</span> {counts.bachelors ? <span className='badge bg-primary'>{counts.bachelors}</span> : ''}
                </Button>
                <Button
                    className='d-flex justify-content-between'
                    variant={toggle == 'associates' ? 'active' : ''}
                    onClick={(e) => {
                        let newFormData = { ...formData };
                        newFormData.filter = 'ic2025';
                        newFormData.toggle = 'associates';
                        setToggle('associates')
                        onFormChange(newFormData);
                    }}>
                    <span>Primarily Associate</span> {counts.associates ? <span className='badge bg-primary'>{counts.associates}</span> : ''}
                </Button>
                <Button
                    className='d-flex justify-content-between'
                    variant={toggle == 'sf' ? 'active' : ''}
                    onClick={(e) => {
                        let newFormData = { ...formData };
                        newFormData.filter = 'ic2025';
                        newFormData.toggle = 'sf';
                        setToggle('sf')
                        onFormChange(newFormData);
                    }}>
                    <span>Special Focus Mixed Levels</span> {counts.sf ? <div className='badge bg-primary'>{counts.sf}</div> : ''}
                </Button>
            </ButtonGroup>

            <Form.Group className="my-3">
                <Form.Label style={{
                    fontWeight: 600,
                    color: '#0d2f4f'
                }}
                    htmlFor="institution"
                >
                    SEARCH BY INSTITUTION NAME
                </Form.Label>
                <InputGroup className="mb-3">
                    <Form.Control
                        id="institution"
                        onChange={(e) => {
                            e.preventDefault();
                            let newFormData = { ...formData };
                            newFormData.institution = e.target.value;
                            onFormChange(newFormData, false);
                        }}
                        onBlur={(e) => {
                            e.preventDefault();
                            let newFormData = { ...formData };
                            newFormData.institution = e.target.value;
                            onFormChange(newFormData, true);
                        }}
                        value={formData.institution}
                        aria-label="Institution Search"
                        aria-describedby="searchIcon"
                    />
                    <InputGroup.Text id="searchIcon"><FaSearch /></InputGroup.Text>
                </InputGroup>
            </Form.Group>
            <div className="accordion accordion-flush" id="search-filter-accordion">
                <AccordionItem title="2025 Institutional Classification">
                    <Accordion alwaysOpen>
                        <Form.Group className="mb-3">
                            {
                                Object.keys(ic2025).map((key, items) => {
                                    return (
                                        <div key={key} className="subFilter">
                                            <Accordion.Item eventKey={key} className='sub-accordion'>
                                                <Accordion.Header className="institution-filter-subtitle" as='div'>{key}</Accordion.Header>
                                                <Accordion.Body className="institute-filter-internal-collapse">
                                                    {ic2025[key].map((c, i) => {
                                                        //if (formData.toggle != c.tab) return;
                                                        return (
                                                            <Form.Check
                                                                key={i}
                                                                type="checkbox"
                                                                id={`ic2025-${key}-${i}`}
                                                                value={c.value}
                                                                label={c.label}
                                                                checked={handleChecked('ic2025', c.value)}
                                                                onChange={(e) => {
                                                                    handleFormChange('ic2025', parseInt(e.target.value));
                                                                }} />
                                                        )
                                                    })}
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </div>
                                    )
                                })
                            }
                        </Form.Group>
                    </Accordion>
                </AccordionItem>
                <AccordionItem title="2025 Student Access and Earnings Classification">
                    <Form.Group className="mb-3">
                        {
                            saec2025.map((c, i) => {
                                return (
                                    <Form.Check
                                        key={i}
                                        type="checkbox"
                                        id={`saec2025${i}`}
                                        value={c.value}
                                        label={c.label}
                                        checked={handleChecked('saec2025', c.value)}
                                        onChange={(e) => {
                                            handleFormChange('saec2025', parseInt(e.target.value));
                                        }} />
                                )
                            })
                        }
                    </Form.Group>
                </AccordionItem>
                <AccordionItem title="2025 Research Activity Designation">
                    <Form.Group className="mb-3">
                        {
                            research.map((c, i) => {
                                return (
                                    <Form.Check
                                        key={i}
                                        type="checkbox"
                                        id={`research${i}`}
                                        value={c.value}
                                        label={c.label}
                                        checked={handleChecked('research2025', c.value)}
                                        onChange={(e) => {
                                            handleFormChange('research2025', parseInt(e.target.value));
                                        }} />
                                )
                            })
                        }
                    </Form.Group>
                </AccordionItem>
                <AccordionItem title="2025 Award Level Focus">
                    <Form.Group className="mb-3">
                        {
                            alf.map((c, i) => {
                                return (
                                    <Form.Check
                                        key={i}
                                        type="checkbox"
                                        id={`alf${i}`}
                                        value={c.value}
                                        label={c.label}
                                        checked={handleChecked('alf', c.value)}
                                        onChange={(e) => {
                                            handleFormChange('alf', parseInt(e.target.value));
                                        }} />
                                )
                            })
                        }
                    </Form.Group>
                </AccordionItem>
                <AccordionItem title="Control">
                    <Form.Group className="mb-3">
                        {
                            control.map((c, i) => {
                                return (
                                    <Form.Check
                                        key={i}
                                        type="checkbox"
                                        id={`control${i}`}
                                        value={c.value}
                                        label={c.label}
                                        checked={handleChecked('control', c.value)}
                                        onChange={(e) => {
                                            handleFormChange('control', parseInt(e.target.value));
                                        }} />
                                )
                            })
                        }
                    </Form.Group>
                </AccordionItem>
                <AccordionItem title="State">
                    <Form.Group className="mb-3">
                        <Form.Select
                            aria-label="Select a state"
                            className='mb-3'
                            value={formData.stabbr}
                            id='stateSelect'
                            onChange={(e) => {
                                let newFormData = { ...formData };
                                if (e.target.value !== '') {
                                    newFormData.stabbr = e.target.value;
                                } else {
                                    delete newFormData.stabbr;
                                }
                                onFormChange(newFormData);
                            }}>
                            <option value="">Select one...</option>
                            {
                                Object.entries(states).map(([key, value], i) => {
                                    return (
                                        <option key={i} value={key}>
                                            {value}
                                        </option>
                                    )
                                })
                            }
                        </Form.Select>
                    </Form.Group>
                </AccordionItem>
                <AccordionItem title="Institution Size">
                    <Form.Group className="mb-3">
                        {
                            size.map((c, i) => {
                                return (
                                    <Form.Check
                                        key={i}
                                        type="checkbox"
                                        id={`size${i}`}
                                        value={c.value}
                                        label={c.label}
                                        checked={handleChecked('size', c.value)}
                                        onChange={(e) => {
                                            handleFormChange('size', parseInt(e.target.value));
                                        }} />
                                )
                            })
                        }
                    </Form.Group>
                </AccordionItem>
                <AccordionItem title="Population Served">
                    <Form.Group className="mb-3">
                        <Form.Check
                            type="checkbox"
                            id={`hbcu`}
                            value={formData.hbcu}
                            label={"Historically Black Colleges and Universities"}
                            checked={handleChecked('hbcu', 1)}
                            onChange={(e) => {
                                handleFormChange('hbcu', 1);
                            }}
                        />
                        <Form.Check
                            type="checkbox"
                            role="menuitemcheckbox"
                            id={`pbi`}
                            value={formData.pbi}
                            label={"Predominantly Black Institutions"}
                            checked={handleChecked('pbi', 1)}
                            onChange={(e) => {
                                handleFormChange('pbi', 1);
                            }}
                        />
                        <Form.Check
                            type="checkbox"
                            id={`tribal`}
                            value={formData.tribal}
                            label={"Tribal Colleges and Universities"}
                            checked={handleChecked('tribal', 1)}
                            onChange={(e) => {
                                handleFormChange('tribal', 1);
                            }}
                        />
                        <Form.Check
                            type="checkbox"
                            id={`aanapisi`}
                            value={formData.aanapisi}
                            label={"Asian American and Native American Pacific Islander Serving Institutions"}
                            checked={handleChecked('aanapisi', 1)}
                            onChange={(e) => {
                                handleFormChange('aanapisi', 1);
                            }}
                        />
                        <Form.Check
                            type="checkbox"
                            id={`hsi`}
                            value={formData.hsi}
                            label={"Hispanic Serving Institutions"}
                            checked={handleChecked('hsi', 1)}
                            onChange={(e) => {
                                handleFormChange('hsi', 1);
                            }}
                        />
                        <Form.Check
                            type="checkbox"
                            id={`nasnti`}
                            value={formData.nasnti}
                            label={"Native American-Serving Nontribal Institutions"}
                            checked={handleChecked('nasnti', 1)}
                            onChange={(e) => {
                                handleFormChange('nasnti', 1);
                            }}
                        />
                        <Form.Check
                            type="checkbox"
                            id={`landgrnt`}
                            value={formData.landgrnt}
                            label={"Land Grant Institutions"}
                            checked={handleChecked('landgrnt', 1)}
                            onChange={(e) => {
                                handleFormChange('landgrnt', 1);
                            }}
                        />
                        <Form.Check
                            type="checkbox"
                            id={`womens`}
                            value={formData.womens}
                            label={"Women's Colleges"}
                            checked={handleChecked('womens', 1)}
                            onChange={(e) => {
                                handleFormChange('womens', 1);
                            }}
                        />
                    </Form.Group>
                </AccordionItem>
                <AccordionItem title="Elective Classifications">
                    <Form.Check
                        type="checkbox"
                        id={`cce`}
                        value={formData.cce}
                        label={"Community Engagement"}
                        checked={handleChecked('cce', 1)}
                        onChange={(e) => {
                            handleFormChange('cce', 1);
                        }}
                    />
                    <Form.Check
                        type="checkbox"
                        id={`lpp`}
                        value={formData.lpp}
                        label={"Leadership for Public Purpose"}
                        checked={handleChecked('lpp', 1)}
                        onChange={(e) => {
                            handleFormChange('lpp', 1);
                        }}
                    />
                </AccordionItem>
            </div>
        </Form >
    )
}

const AccordionItem = ({ title, expanded = false, children }) => {
    const slug = title.replace(/\s+/g, '-').toLowerCase();
    const id = `flush-collapse${slug}`;
    return (
        <div className="accordion-item">
            <h2 className="accordion-header" id={`header-${slug}`} style={{ lineHeight: "90%" }}>
                <button
                    id={`header-${id}`}
                    className={`accordion-button px-3 ${expanded ? '' : 'collapsed'}`}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#accordion-${id}`}
                    aria-expanded={expanded}
                    aria-controls={`#accordion-${id}`}
                >
                    {title}
                </button>
            </h2>
            <div
                id={`accordion-${id}`}
                className={`accordion-collapse ${expanded ? '' : 'collapse'}`}
                aria-labelledby={`header-${id}`}
            >
                <div className="accordion-body px-2 py-3">
                    {children}
                </div>
            </div>
        </div>
    )
}